import Injection = EECore.Injection;
import { WidgetResources } from "../../resources/widget";
import Model from "../models/login/loginModel";

@Injection.injectableClass("EEWidget.Login")
export default class Login implements EECore.UI.IWebComponent {
  @Injection.injectableProperty("EEWidget.Login", "WidgetResources")
  private resources: WidgetResources;

  @Injection.injectableProperty("EEWidget.Login", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("EEWidget.Login", EECore.Registrations.URL_HELPER)
  private urlHelper: EECore.Helpers.UrlHelper;

  @Injection.injectableProperty("EEWidget.Login", EECore.Registrations.DOCUMENT)
  private document: Document;

  @Injection.injectableProperty("EEWidget.Login", EECore.Registrations.AUTH_SERVICE)
  private authService: EECore.Services.AuthService;

  constructor(templateFactory: EECore.UI.TemplateFactory,
    resources: WidgetResources,
    urlHelper: EECore.Helpers.UrlHelper,
    document: Document,
    authService: EECore.Services.AuthService) {
    this.templateFactory = templateFactory;
    this.resources = resources;
    this.urlHelper = urlHelper;
    this.document = document;
    this.authService = authService;
  }

  load() {
    return this.renderTemplate();
  }

  private renderTemplate(): Element {
    if (this.authService.isAuthenticated()) {
      this.authService.validateAuthentication();
      return this.document.createDocumentFragment() as any;
    }

    const model = new Model();
    model.title = this.resources.login.title;
    model.submitButton = this.resources.login.submitButton;
    model.registrationLabel = this.resources.login.registrationLabel;
    model.loginPageLink = this.urlHelper.processUrl("/wemwpn48/gohome");
    model.registrationLink = this.urlHelper.processUrl("/wemwpn46/");

    const loginElement = this.templateFactory.getTemplate("Login", model);

    return loginElement;
  }
}